import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Accordion } from '../common-components/accordion';
import { SectionInfo, SectionInfoProps } from '../common-components/sectionInfo';

export const PatientPayerDetails = React.memo(({ data }: { data: SectionInfoProps[] }) => {
  const { t } = useTranslation('insurance-eligibility-report');
  return (
    <Accordion css={cardStyles} accordionId='patientPayerDetails' accordionTitle={t('Patient and Payer Details')}>
      <div css={cardStyles}>
        {data.map((item, index) => (
          <div key={index}>
            <SectionInfo label={item.label} value={item.value} />
          </div>
        ))}
      </div>
    </Accordion>
  );
});

PatientPayerDetails.displayName = 'PatientPayerDetails';

const cardStyles = css`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  row-gap: ${theme.spacing(2)};
  column-gap: ${theme.spacing(4)};
`;
